export default "__VITE_PUBLIC_ASSET__9c88fc79__"